import React, { Component } from 'react';

export const MoreActions = ({children, className}) => {
  return (
    <div className={`more-actions ${className ? className : ''}`}>
    	{children}	
    </div>
  )
}
